export default {
    options: [
        {
            name: "English",
            value: "en",
        },
        {
            name: "Español",
            value: "es",
        },
        {
            name: "French",
            value: "fr"
        },
    ],
}


// WEBPACK FOOTER //
// ./src/components/Language/option.js